import React from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import CategorySlider from "../../../CategorySlider";

/* ================= ALL INDIA CITY DATA ================= */

const allCities = [
  { slug: "ahmedabad", city: "Ahmedabad", state: "Gujarat" },
  { slug: "surat", city: "Surat", state: "Gujarat" },
  { slug: "vadodara", city: "Vadodara", state: "Gujarat" },
  { slug: "rajkot", city: "Rajkot", state: "Gujarat" },
  { slug: "gandhinagar", city: "Gandhinagar", state: "Gujarat" },

  { slug: "delhi", city: "Delhi", state: "Delhi NCR" },
  { slug: "noida", city: "Noida", state: "Delhi NCR" },
  { slug: "gurugram", city: "Gurugram", state: "Delhi NCR" },

  { slug: "mumbai", city: "Mumbai", state: "Maharashtra" },
  { slug: "pune", city: "Pune", state: "Maharashtra" },

  { slug: "bangalore", city: "Bengaluru", state: "Karnataka" },
  { slug: "chennai", city: "Chennai", state: "Tamil Nadu" },
  { slug: "hyderabad", city: "Hyderabad", state: "Telangana" },
  { slug: "jaipur", city: "Jaipur", state: "Rajasthan" }
];

const Gujarat = () => {
  const { city } = useParams();
  const cityData = allCities.find((c) => c.slug === city);

  if (!cityData) {
    return (
      <div style={{ marginTop: "120px", padding: "30px" }}>
        <h2>City not found</h2>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Sex Toys in {cityData.city} | Discreet Delivery in {cityData.state}
        </title>
        <meta
          name="description"
          content={`Buy sex toys in ${cityData.city} with fast & discreet delivery. Premium adult toys, couples wellness products & COD available in ${cityData.state}.`}
        />
      </Helmet>
<CategorySlider />
      <div
        style={{
          
          padding: "25px",
          backgroundColor: "#FFF5F5",
          minHeight: "90vh",
          lineHeight: "1.7"
        }}
      >
        {/* H1 */}
        <h1>Sex Toys in {cityData.city}</h1>
        <p>
          Welcome to LushDesire — your trusted destination to buy{" "}
          <strong>sex toys in {cityData.city}</strong>. We provide premium adult
          toys and couples wellness products with 100% discreet delivery across{" "}
          {cityData.state}. Our products are safe, body-friendly, and carefully
          curated for pleasure, comfort, and satisfaction.
        </p>

        {/* H2 */}
        <h2>Buy Sex Toys Online in {cityData.city}</h2>
        <p>
          Buying sex toys online in {cityData.city} has never been easier. At
          LushDesire, we offer a wide collection of original and high-quality
          adult toys for men, women, and couples. Whether you are exploring
          pleasure for the first time or enhancing your intimate moments, our
          online store ensures a smooth, secure, and private shopping
          experience.
        </p>

        <p>
          We understand privacy concerns in India, which is why every order is
          packed in plain, unbranded boxes. No product names, no logos, and no
          awkward moments — just complete confidentiality.
        </p>

        {/* H3 */}
        <h3>Popular Sex Toys Available in {cityData.city}</h3>
        <p>
          Our adult toy collection in {cityData.city} includes carefully
          selected products designed for pleasure and wellness:
        </p>
        <ul>
          <li>✔ Vibrators & Bullet Massagers</li>
          <li>✔ Dildos & Realistic Toys</li>
          <li>✔ Couples Sex Toys</li>
          <li>✔ Male Masturbators & Delay Sprays</li>
          <li>✔ Female Pleasure & Wellness Products</li>
        </ul>

        {/* H3 */}
        <h3>Why Choose LushDesire in {cityData.city}?</h3>
        <p>
          LushDesire is more than just an adult store. We focus on trust,
          authenticity, and customer satisfaction. Thousands of customers
          across India rely on us for discreet and reliable sex toy delivery.
        </p>

        <ul>
          <li>✔ 100% Discreet Packaging</li>
          <li>✔ Fast Local Delivery in {cityData.city}</li>
          <li>✔ Cash on Delivery (COD) Available</li>
          <li>✔ Secure Online Payments</li>
          <li>✔ Original & Safe Products</li>
        </ul>

        {/* H4 */}
        <h4>Discreet Sex Toys Delivery in {cityData.state}</h4>
        <p>
          Privacy is our top priority. All sex toys delivered in{" "}
          {cityData.state} are packed securely with no indication of adult
          content. Our delivery partners maintain strict confidentiality so you
          can shop with complete peace of mind.
        </p>

        <p>
          We deliver to homes, offices, and private locations across{" "}
          {cityData.city}. Fast shipping and careful handling ensure your order
          reaches you safely and discreetly.
        </p>

        {/* H5 */}
        <h5>Order Sex Toys in {cityData.city} Today</h5>
        <p>
          Ready to explore pleasure? Order sex toys online in{" "}
          {cityData.city} today from LushDesire and experience premium quality,
          privacy, and trusted service. Your satisfaction and confidentiality
          are always guaranteed.
        </p>

        <p>
          Choose LushDesire — India’s reliable online destination for sex toys
          and couples wellness products.
        </p>
      </div>
    </>
  );
};

export default Gujarat;
